import { useState } from 'react'
import { HaloUserCombobox } from '@/features/halocrm-user/HaloUserCombobox'
import { useHaloUser } from '@/features/halocrm-user/hooks'
import { useChangeContractSalesPerson } from '../hooks'

type Props = {
  contractId: number
  salesPersonId: number | null
}

export function SalesPersonWidget({ contractId, salesPersonId }: Props) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState<number | null>(salesPersonId)
  const change = useChangeContractSalesPerson(contractId)
  const resolved = useHaloUser(salesPersonId)

  const displayName = (() => {
    if (salesPersonId == null) return 'Brak'
    if (resolved.isLoading) return 'Ładowanie...'
    if (resolved.data) return resolved.data.fullName
    return `#${salesPersonId}`
  })()

  const handleSave = () => {
    change.mutate(draft, { onSuccess: () => setEditing(false) })
  }

  if (!editing) {
    return (
      <div className="flex items-center gap-2 text-sm">
        <span className="text-slate-500 text-xs uppercase">Handlowiec:</span>
        <span>{displayName}</span>
        <button
          type="button"
          onClick={() => { setDraft(salesPersonId); setEditing(true) }}
          className="text-xs text-sky-600 hover:underline"
        >
          Zmień
        </button>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-slate-500 text-xs uppercase">Handlowiec:</span>
      <div className="w-56">
        <HaloUserCombobox
          value={draft}
          onChange={setDraft}
          placeholder="Wybierz handlowca..."
          showInactiveByDefault
        />
      </div>
      <button
        type="button"
        onClick={handleSave}
        disabled={change.isPending}
        className="text-xs bg-sky-600 text-white px-2 py-1 rounded disabled:opacity-50"
      >
        Zapisz
      </button>
      <button
        type="button"
        onClick={() => setEditing(false)}
        className="text-xs text-slate-500 hover:underline"
      >
        Anuluj
      </button>
    </div>
  )
}
